// Sun Valley : lien « Gérer les cookies » du pied de page (menu, adresse « #cookies »). La CNIL
// exige qu'on puisse retirer son consentement aussi facilement qu'on l'a donné : le lien rouvre
// les préférences du bandeau cookies de Shopify. À défaut de bandeau (pays où Shopify ne l'affiche
// pas), il mène à la politique de confidentialité.
(() => {
  document.addEventListener('click', (e) => {
    const lien = e.target.closest('a[href$="#cookies"]');
    if (!lien) return;
    e.preventDefault();
    if (window.privacyBanner?.showPreferences) window.privacyBanner.showPreferences();
    else location.href = (window.Shopify?.routes?.root || '/') + 'policies/privacy-policy';
  });
})();
